module.exports = __webpack_public_path__ + "img/spartan-carpentry-millwork-cabinetry-07-tablet.960b4bf6.jpg";